import { useBusinessCreateStore } from '../../store/business-create-store'

import BusinessCreateExactLocationsStep from './locations/exact-locations'
import BusinessCreateGeneralLocationsStep from './locations/general-locations'

const BusinessSelectLocationStep = () => {
  const { formData } = useBusinessCreateStore()
  const locationType = formData.desiredLocationType || 'general'

  if (locationType === 'exact') {
    return <BusinessCreateExactLocationsStep />
  } else {
    return <BusinessCreateGeneralLocationsStep />
  }
}

export default BusinessSelectLocationStep
